import { useEffect, useRef } from 'react';
import closeIcon from '../assets/icons/closeBlack.svg';
import Button from './Button';
type IProps = {
	isModalOpen: boolean;
	titleMessage: string;
	subTitleMessage: string;
	handleClickYes: () => void;
	handleClickNo: () => void;
	hasOverlayClick?: boolean;
};
const Modal = ({
	titleMessage,
	subTitleMessage,
	handleClickNo,
	handleClickYes,
	isModalOpen,
	hasOverlayClick = true,
}: IProps) => {
	const ref = useRef<HTMLDivElement>(null);

	const onClickNo = () => {
		handleClickNo?.();
	};

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const handleClickOutside = (e: any) => {
		if (
			hasOverlayClick &&
			ref.current &&
			!ref.current?.contains(e.target)
		) {
			onClickNo();
		}
	};

	useEffect(() => {
		window.addEventListener('click', handleClickOutside, { capture: true });
		return () => {
			window.removeEventListener('click', handleClickOutside, {
				capture: true,
			});
		};
	}, [ref.current, isModalOpen]);

	const onClickYes = () => {
		handleClickYes();
	};

	return (
		<>
			{isModalOpen ? (
				<div className="fixed min-w-[100vw] bg-black bg-opacity-60 min-h-[100vh] z-[100] flex justify-center items-center">
					<div
						ref={ref}
						className="w-[600px] h-[220px] flex flex-col border-2 rounded-lg"
					>
						<div className="flex p-4 flex-col h-[150px] bg-rcrm-light-red border-b-2 border-rcrm-primary-border-blue gap-y-2">
							<div className="flex justify-between gap-x-2 items-center">
								<div className="font-semibold text-xl">
									{titleMessage}
								</div>
								<img
									className="w-6 h-6 cursor-pointer"
									src={closeIcon}
									alt=""
									onClick={() => handleClickNo()}
								/>
							</div>
							<div>{subTitleMessage}</div>
						</div>
						<div className="p-4 h-[80px] bg-white">
							<div className="flex justify-end gap-x-2">
								<Button
									label="No"
									onButtonClick={onClickNo}
									buttonStyle="bg-white border-2 hover:bg-rcrm-primary-border-blue"
									labelStyle="text-rcrm-text-gray"
								/>
								<Button
									label="Yes"
									onButtonClick={onClickYes}
									buttonStyle="bg-rcrm-error hover:bg-rcrm-hover-red"
									labelStyle="text-white"
								/>
							</div>
						</div>
					</div>
				</div>
			) : null}
		</>
	);
};

export default Modal;
